import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-form-divider',
  templateUrl: './form-divider.component.html',
  styleUrls: ['./form-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDividerComponent implements OnInit {
  @Input() text = '';
  @Input() textClass = '';

  ngOnInit() {
  }
}
